import './FreelancerResult.scss';

import React from 'react';
import PropTypes from 'prop-types';

import A from 'components/A'
import Avatar from 'components/Avatar';
import Button from 'components/Button';
import CircleIcon from 'components/CircleIcon';
import H2 from 'components/H2';
import FreelancerMetadata from "../FreelancerMetadata";
import {renderSpecializationString} from "../../../../utils/utils";
import Checkbox from "../../../../components/Checkbox";


export default class FreelancerResult extends React.Component {
    static propTypes = {
        handleMessageCheckboxClick: PropTypes.func.isRequired,
        handleMessageClick: PropTypes.func.isRequired,
        id: PropTypes.number.isRequired,
        experienceYears: PropTypes.string.isRequired,
        profilePic: PropTypes.string,
        selectedProfilesToDM: PropTypes.array,
        specializations: PropTypes.array,
        title: PropTypes.string.isRequired,
    };

    checkboxChecked() {
        return this.props.selectedProfilesToDM.find((p) => p.id === this.props.id) != null;
    }

    render() {
        return (
            <div className="freelancersresult">
                {this.props.handleMessageCheckboxClick && this.props.selectedProfilesToDM && (
                    <Checkbox
                        checked={this.checkboxChecked()}
                        id={`chkDM${this.props.id}`}
                        onChange={this.props.handleMessageCheckboxClick}
                    />
                )}
                <Avatar imageUrl={this.props.profilePic} />
                <div className="freelancerheader">
                    <H2>
                        <A to={`/freelancer/${this.props.id}`}>
                            {this.props.title}
                        </A>
                    </H2>
                    <div className="freelancersresult-actions">
                        <Button className="profile__action"
                            noStyles
                            onClick={this.props.handleMessageClick.bind(this)}>
                            <span className="profile__action-icon--wrapper">
                                <CircleIcon type="email" />
                            </span>
                        </Button>


                        {/*<Button className="profile__action"
                                noStyles
                                onClick={() => alert('Favorite this freelancer')}>
                            <span className="profile__action-icon--wrapper">
                                <CircleIcon type="heart" />
                            </span>
                        </Button>*/}
                    </div>
                    <FreelancerMetadata
                        specializations={this.props.specializations}
                        experienceYears={this.props.experienceYears}
                    />
                </div>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/containers/Freelancers/components/FreelancerResult/index.js